module.exports = __webpack_public_path__ + "static/media/calendar-ach12_150.2658407a.gif";